import _ from 'lodash';
import { checkFakeSubscription, checkModalSubscription } from '../../helper';

/**
 *
 * @param a
 * @param b
 * @returns {number}
 */
export const sortByChoose = (a, b) => {
  if (a?.value === '' || b?.value === '') {
    return -1;
  }
  return 0;
}

export const getOptions = (list, options, modal, subscription_type) => {
  if (_.isObject(list)) {
    const isFakeSubscription = checkFakeSubscription(modal);
    const isSubscription = checkModalSubscription(modal);
    const isEditModal = !!modal;
    /**
     * Если сервис Fake subscription
     * Фильтруем все сервисы по параметру
     * subscription_type
     * Должен совпадать с form.subscription_type
     *
     */
    if (isFakeSubscription) {
      return Object.keys(list)
        .filter((key) => {
          if (options) {
            const option = options[key];
            // TODO
            // service_link_type - это subscription_type
            if (subscription_type && option?.service_link_type) {
              const serviceSubscriptionType = Number(option.service_link_type);
              const formSubscriptionType = Number(subscription_type);
              return serviceSubscriptionType === formSubscriptionType;
            }
          }
          return false;
        })
        .map((key) => ({
          label: list[key],
          value: key,
        }))
    }

    /**
     * Если сервис Subscription
     * Фильтруем все сервисы по Default типу
     * ID Default type = 0
     */
    if (isSubscription) {
      return Object.keys(list)
        .filter((key) => {
          if (options) {
            const option = options[key];
            if (option?.hasOwnProperty('service_type')) {
              const serviceType = Number(option.service_type);
              // Default type = 0
              if (serviceType === 0) {
                return true;
              }
            }
          }
          return false;
        })
        .map((key) => ({
          label: list[key],
          value: key,
        }))
    }

    /**
     * При редактировании услуги
     * убираем из списка все Subscription услуги,
     * Если услуга уже была выбара - ее оставляем
     *
     * Таска https://www.notion.so/perfectpanel/23d97e7f9fee4a9bb9244f9af14dd68e
     */
    if (isEditModal) {
      return Object.keys(list)
        .filter((key) => {
          if (options) {
            const option = options[key];
            if (option?.service_type === 100 || option?.service_type === 101) {
              return !!(modal.provider_service_id && `${modal.provider_service_id}` === `${key}`);
            }
          }
          return true
        })
        .map((key) => ({
          label: list[key],
          value: key,
        }))
        .sort(sortByChoose)
    }
    return Object.keys(list)
      .map((key) => ({
        label: list[key],
        value: key,
      }))
      .sort(sortByChoose)
  }
  return [];
};

export const getSelectedValue = (options, value) => {
  if (_.isArray(options)) {
    const newValue = _.isNull(value) ? '' : value;
    const findValue = options.find((option) => option.value === newValue);
    if (findValue) {
      return findValue;
    }
  }
  return null;
};
